module.exports = __webpack_public_path__ + "static/media/payment-icon.0938f6a5.svg";